module.exports = __webpack_public_path__ + "img/bglogo.21d87185.png";